import type React from 'react';

import { BannerContainer } from '../containers/BannerSection';
import { DetailsContainer } from '../containers/Details';

import { useShowSurvey } from './hooks/useShowSurvey';
import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	useShowSurvey();

	return (
		<>
			<BannerContainer />
			<DetailsContainer />
		</>
	);
};
